// 配置文档：https://dashen.zhuanspirit.com/pages/viewpage.action?pageId=391545514  可联系：谢星
// pageId 申请的页面：https://zznba.zhuanspirit.com/#/data/page
// 统跳链接申请页面：https://jump.zhuanspirit.com/#/weburls
import { url as URL } from '@zz-yp/hunter-js-utils'
const infoId = URL.getParam('infoId') || ''
export default {
  pagequery: '', // 设置pagequery参数，后续埋点都会发送
  infoId: infoId, // 设置infoId参数，后续埋点都会发送
  stayUserTime: true, // 统计用户在页面停留时长  会将 routeList 中配置的路由 pageId 进行上报，如页面不在 routeList 中，则为 noPageId
  forbidLegoInPrerender: true, // 预渲染页 禁止发送埋点
  autoGoodsExpose: true, // 是否自动曝光商品
  // 需要统计数据的路由列表
  routeList: [
    // 暗拍手机卖场【下午场】
    {
      name: 'matinee-list',
      route: '/secret-auction/matinee-list',
      pageId: 'A9569', // pageId从zeye上拷贝
      level: 1, // 页面级别
      isDetailPage: false // 是否是详情页，为true的时候，zpmshow埋点的pagetype就变成了CommodityDetail
    },
    // 暗拍手机卖场【晚上场】
    {
      name: 'mobile-list',
      route: '/secret-auction/mobile-list',
      pageId: 'V2855', // pageId从zeye上拷贝
      level: 1, // 页面级别
      isDetailPage: false // 是否是详情页，为true的时候，zpmshow埋点的pagetype就变成了CommodityDetail
    },
    // 暗拍数码卖场
    {
      name: 'tablets-list',
      route: '/secret-auction/tablets-list',
      pageId: 'E1150', // pageId从zeye上拷贝
      level: 1, // 页面级别
      isDetailPage: false // 是否是详情页，为true的时候，zpmshow埋点的pagetype就变成了CommodityDetail
    },
    // 暗拍商品详情页
    {
      name: 'secret-auction-detail',
      route: '/secret-auction/detail',
      pageId: 'J2415', // pageId从zeye上拷贝
      level: 2, // 页面级别
      isDetailPage: true // 是否是详情页，为true的时候，zpmshow埋点的pagetype就变成了CommodityDetail
    },
    // 一口价商品详情页
    {
      name: 'new-one-price-detail',
      route: '/new-one-price/detail',
      pageId: 'I8586', // pageId从zeye上拷贝
      level: 2, // 页面级别
      isDetailPage: true // 是否是详情页，为true的时候，zpmshow埋点的pagetype就变成了CommodityDetail
    },
    //查成交价列表
    {
      name: 'list',
      route: '/real-deal-price/list',
      pageId: 'C7477', // pageId从zeye上拷贝
      level: 1, // 页面级别
      isDetailPage: false // 是否是详情页，为true的时候，zpmshow埋点的pagetype就变成了CommodityDetail
    },
    // 首页
    {
      name: 'index',
      route: '/index',
      pageId: 'R4343', // pageId从zeye上拷贝
      level: 1, // 页面级别
      isDetailPage: false // 是否是详情页，为true的时候，zpmshow埋点的pagetype就变成了CommodityDetail
    },
    // 一口价列表页
    {
      name: 'new-one-price-list',
      route: '/new-one-price/list',
      pageId: 'O1632', // pageId从zeye上拷贝
      level: 1, // 页面级别
      isDetailPage: false // 是否是详情页，为true的时候，zpmshow埋点的pagetype就变成了CommodityDetail
    },
    // 店铺页面
    {
      name: 'store-index',
      route: '/store/store-index',
      pageId: 'R7311', // pageId从zeye上拷贝
      level: 2, // 页面级别
      isDetailPage: false // 是否是详情页，为true的时候，zpmshow埋点的pagetype就变成了CommodityDetail
    },
    // 店铺详情页
    {
      name: 'new-one-price-search',
      route: '/new-one-price/search',
      pageId: 'G1347', // pageId从zeye上拷贝
      level: 2, // 页面级别
      isDetailPage: false // 是否是详情页，为true的时候，zpmshow埋点的pagetype就变成了CommodityDetail
    }
  ]
}
